site.mMenu = {
	init: function() {
		var $menu = $('>.contentWrap >.mmLevel1', '#mainmenu');
		if ($menu.length === 0) return false;

		var $body = $('body'),
			$html = $('<div id="mMenu" role="navigation"></div>'),
			$mMenu = $menu.clone().removeAttr('id');
		$('ul',$mMenu).removeAttr('id');
		$html.append($mMenu);
		$body.append($html);

		var $navbar = '<a href="#mm-1" class="home"><span class="sr-only">Heim</span></a>';
		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $navbar,
			}]
		},{
			// configuration
			classNames: {
				selected:"active"
			},
			offCanvas: {
				menuInjectMethod: "append"
			}
		});

		var API = $("#mMenu").data( "mmenu" );

		$("#mainmenuToggle").click(function() {
			API.close();
		});


		$('.mm-page.mm-slideout').removeClass('mm-slideout');

		//var $mSearch = $('#searchForm').clone().prop('id','mSearchForm');
		//$('.mm-navbar-top','#mMenu').append($mSearch);

		$('#mMenu .mm-next').append('<span class="sr-only">Áfram</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Aftur</span>');
		$('#mSearchForm label').remove();

		var $div = $('.mm-panel:first-child', '.mm-panels');
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === "class") {
					var attributeValue = $(mutation.target).prop(mutation.attributeName);
					//if ($body.hasClass('')
					if (attributeValue.indexOf('mm-subopened') > 0) {
						$body.addClass('mm-subopened');
					}
					else {
						$body.removeClass('mm-subopened');
					}

				}
			});
		});
		observer.observe($div[0], {
			attributes: true
		});

		if ($div.hasClass('mm-subopened')) {
			$body.addClass('mm-subopened');
		}

		site.mMenu.appendQn();
		site.mMenu.appendSearchBox();
	},

	appendQn: function() {
		var $menu = $('.mm-panel:first-child .mmLevel1'),
			$qn = $('#qn').clone();
		$qn = $('<div class="mobileQn">' + $qn.html() + '</div>');
		$qn.appendTo($menu);
	},

	appendSearchBox:function() {
		var $searchForm = $('#searchForm').clone().removeAttr('id').addClass('searchForm').wrap('<li class="mmSearch">').parent();
		$searchForm.find('#q').removeAttr('id').attr('id', 'mQ');
		$searchForm.find('#searchSubmit').removeAttr('id').attr('id', 'mSearchSubmit');
		$searchForm.find('#elm_submit').removeAttr('id').attr('id', 'mElm_submit');
		$searchForm.find('#elm_q').removeAttr('id').attr('id', 'mElm_q');
		$searchForm.find('label').removeAttr('for').attr('for', 'mQ');
		var $mmenuLevel1 = $('#mMenu .mm-panel > .mmLevel1');
		$searchForm.prependTo($mmenuLevel1);
	}
};

//site.inits.push('site.mMenu.init()');
